import React from "react";
import ColorInit from "../../../shared/layout/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Header from "../../../shared/layout/Header";
import ProductListing from "../components/ProductListing";
import Footer from "../../../shared/layout/Footer";
import BottomFooter from "../../../shared/layout/BottomFooter";
import { CartProvider } from "../../cart/context/CartContext";
const ProductsPage = () => {
  return (
    <CartProvider>
      <ScrollToTop smooth color="#ef253c" />

      <ColorInit color={'bigmall'} />

      <Header />

        <div className="container container-lg">
      <ProductListing />
      </div>

      <Footer />
      <BottomFooter />
    </CartProvider>
  );
}

export default ProductsPage;
